module.exports = __webpack_public_path__ + "img/logo_valle_plus.5a6c053.svg";


//////////////////
// WEBPACK FOOTER
// ./static/logo_valle_plus.svg
// module id = L31Z
// module chunks = 1